/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type BenefitsChartHeader_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type BenefitsChart_viewer$ref: FragmentReference;
export type BenefitsChart_viewer = {|
  +$fragmentRefs: BenefitsChartHeader_viewer$ref,
  +$refType: BenefitsChart_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "BenefitsChart_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "BenefitsChartHeader_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'fa89ceeac76f9b688ab6b3432f5aee7a';
module.exports = node;
